<template>
  <div>
  </div>
</template>

<script>
    export default {
        created() {
            this.redirectToAppStore();
        },
        methods: {
            getUserOS(){
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;

                if (/windows phone/i.test(userAgent))
                    return "Windows Phone";

                if (/android/i.test(userAgent)) 
                    return "Android";

                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) 
                    return "iOS";

                return "unknown";
            },
            redirectToAppStore() {
                let os = this.getUserOS();

                if (os == "Android") 
                    window.location.href = "https://play.google.com/store/apps/details?id=com.mobi.usecargo"; 
                else if (os == "iOS")
                    window.location.href = "https://apps.apple.com/br/app/usecar-carsharing/id1494032966#?platform=iphone";
                
                // else if (os == "Windows Phone") {
                //     window.location.href = "http://www.WindowsPhoneexample.com";
                // } else {
                //     window.location.href = "http://www.NowherLandexample.com";
                // }
            },
        },
    
    };
</script>

<style lang="scss">
</style>
